export default __webpack_public_path__ + "static/media/kitchen5-beforeB-1920w.e8f1d0f3.png";